<template>
    <div class="mb-3">
        <b-row>
            <b-col md="12" class="my-1 d-flex">
                <b-button
                    v-if="auth_level >= '100' && formModalId"
                    variant="none"
                    class="mr-2"
                    @click="add"
                    >
                    <font-awesome-icon icon="plus" />
                </b-button>
                <b-form class="flex-grow-1" @submit="search">
                    <b-form-group class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="grid.filters.q"
                                :placeholder="filtersQPlaceholder"
                                type="search"
                                ></b-form-input>
                            <b-input-group-append>
                                <b-button type="submit">
                                    <font-awesome-icon icon="search" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-form>
                <b-button
                    variant="none"
                    class="ml-2"
                    @click="ui.showGridFilter = !ui.showGridFilter"
                    >
                    <font-awesome-icon icon="sliders-h" />
                </b-button>
            </b-col>
            <b-col md="12">
                <b-collapse id="grid-filter" v-model="ui.showGridFilter">
                    <b-row class="mb-3">
                        <filter-item
                        v-for="item in filterItems"
                        :key="item.vModel"
                        v-model="grid.filters[item.vModel]"
                        :title="item.title"
                        :options="item.options"
                        @input="search"
                        />
                    </b-row>
                </b-collapse>
            </b-col>
        </b-row>
    
        <template v-if="grid.response.hits && grid.response.hits.length">
            <b-table
                :items="grid.response.hits"
                :fields="[{ key: 'column', class: 'text-left' }]"
                striped
                hover
                thead-class="font-weight-bold"
                thead-tr-class="d-none"
                @row-clicked="detail"
                >
                <template slot="thead-top" slot-scope="data">
                    <b-row class="d-none d-md-flex p-2">
                        <slot :item="data.item" name="header"></slot>
                    </b-row>
                </template>
                <template v-slot:cell(column)="data">
                    <b-row class="d-flex p-2">
                        <slot :item="data.item" name="column"></slot>
                    </b-row>
                </template>
            </b-table>
    
            <Pagenation
                v-model="grid.filters.page"
                :nb-pages="grid.response.nbPages"
                :nb-hits="grid.response.nbHits"
                @input="pagenation"
                />

        </template>
    
        <slot :form="form" :init="detail" name="form"></slot>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterItem from '@/components/FilterItem.vue'
import Pagenation from '@/components/Pagenation.vue'

export default {
    components: {
        FilterItem,
        Pagenation,
    },
    props: {
        filtersQPlaceholder: {
            type: String,
            required: true,
            default() {
                return 'キーワード'
            },
        },
        filtersDefault: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        filterItems: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        formModalId: {
            type: String,
            required: false,
            default() {
                return ''
            },
        },
        formDefault: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        searchAction: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        afterMount: {
            type: Function,
            required: false,
            default() {
                return function () {}
            },
        },
        openDetailForOneHit: {
            type: Boolean,
            required: false,
            default() {
                return false
            },
        },
        openDetailAfterSaving: {
            type: Boolean,
            required: false,
            default() {
                return true
            },
        },
    },
    data() {
        return {
            grid: {
                filters: {
                    q: '',
                    page: 1,
                },
                response: {},
                error: {},
            },
            form: {
                log: [],
            },
            ui: {
                showGridFilter: false,
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_pages',
            'auth_batches',
        ])
    },
    mounted() {
        setTimeout(() => {
            this.search()
        }, 1000)

        this.grid.filters = Object.assign(this.grid.filters, this.filtersDefault)

        this.$bus.$on('form-modal:save-callback', (response) => {
            this.pushGrid(response.data)
            if (this.openDetailAfterSaving) {
                this.detail(response.data)
            }
        })

        this.$bus.$on('form-modal:destroy-callback', (response) => {
            this.deleteGrid(response.data)
        })

        this.$bus.$on('form-modal:refresh-callback', (id) => {
            let target = this.grid.response.hits.filter((item) => item.id === id);
            if (!target.length) {
                return;
            }
            this.$store
                .dispatch(this.searchAction, {
                    id: id,
                })
                .then((response) => {
                    target[0] = Object.assign(target[0], response.data)
                })
                ;
        })

        if (this.$route.params.id) {
            this.grid.filters.q = this.$route.params.id
        }

        this.afterMount(this)
    },
    methods: {
        // ...mapActions('member', ['searchMember']),
        search(event, page) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.grid.response = {}
            this.grid.error = {}
            this.ui.showGridFilter = false
            this.grid.filters.page = page || 1
            this.$store
            .dispatch(this.searchAction, Object.assign(this.filtersDefault, this.grid.filters))
//            .dispatch(this.searchAction, this.grid.filters)
            .then((response) => {
                this.grid.response = JSON.parse(JSON.stringify(response.data))

                if (this.openDetailForOneHit && this.grid.response.nbHits === 1) {
                    this.detail(this.grid.response.hits[0], 0)
                }
            })
            .catch((error) => {
                this.grid.error = error
            })
        },
        pagenation(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.search(event, this.grid.filters.page)
        },
        add(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            if (!this.formModalId) {
                return
            }
            this.form = JSON.parse(JSON.stringify(this.formDefault))
            this.$bvModal.show(this.formModalId)
        },
        detail(item, index, event) {
            if (!this.formModalId) {
                return
            }
            this.$store
                .dispatch(this.searchAction, { id: item.id })
                .then((response) => {
                    this.form = response.data
                    this.$bvModal.show(this.formModalId)
                })
                .catch((error) => {
                    this.grid.error = error
                })
        },
        pushGrid(item) {
            for (let i = 0; i < this.grid.response.hits.length; i++) {
                if (item.id === this.grid.response.hits[i].id) {
                    this.grid.response.hits[i] = Object.assign(
                    this.grid.response.hits[i],
                    item
                    )
                    return
                }
            }
            this.grid.response.hits.unshift(item)
        },
        deleteGrid(item) {
            for (let i = 0; i < this.grid.response.hits.length; i++) {
                if (item.id === this.grid.response.hits[i].id) {
                    this.grid.response.hits.splice(i, 1)
                    return
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.filter-item-option {
    display: block;

    &[active] {
    }

    &:not([active]) {
        opacity: 0.3;
    }

    [type='radio'] {
        display: none;
    }

    .filter-item-option-text {
        cursor: pointer;
    }
}
</style>
